import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import axios from "axios";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { BASE_URL, security_key } from "../global";

function AdminReportPrimaryStudents() {
    const location = useLocation();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        sessionStorage.setItem("previousPagePathname", location.pathname);
    }, [location.pathname]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL}API/api_index.php`, {
                security_key,
                mode: "getPrimaryStudentCountsAllCentres",
            });

            if (res.data?.success && Array.isArray(res.data.data)) {
                const mapped = res.data.data.map((item, idx) => {
                    const count =
                        item.primary_students ??
                        item.primary_student_count ??
                        item.student_count ??
                        item.count ??
                        0;
                    return {
                        id: idx + 1,
                        pk_cent_key: item.pk_cent_key,
                        cent_name: item.cent_name,
                        primary_count: Number(count) || 0,
                    };
                });
                setRows(mapped);
            } else {
                setRows([]);
            }
        } catch (e) {
            console.error("Fetch primary students by centre failed:", e);
            setRows([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchData(); }, []);

    const columns = [
        { field: "cent_name", headerName: "Centre", flex: 1, headerClassName: "super-app-theme--header" },
        { field: "primary_count", headerName: "Primary Students (≤ Year 6)", flex: 1, headerClassName: "super-app-theme--header" },
    ];

    return (
        <div>
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <div>
                    <h5 className="page-title">Primary Students by Centre</h5>
                    <Breadcrumbs aria-label="breadcrumb" className="my-breadcrumbs">
                        <NavLink to="/calendar">Home</NavLink>
                        <NavLink to="/reports">Reports</NavLink>
                        <Typography color="text.primary">Primary Students</Typography>
                    </Breadcrumbs>
                </div>
            </div>

            <Card className="card my-card mb-3">
                <Card.Body>
                    <Row>
                        <Col xs="12">
                            <Box
                                sx={{
                                    width: "100%",
                                    overflowX: "auto",
                                    "& .super-app-theme--header": { backgroundColor: "#f4f4f4", whiteSpace: "normal" },
                                    "& .MuiDataGrid-cell": { whiteSpace: "normal", wordWrap: "break-word" },
                                    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus": { outline: "none" },
                                }}
                            >
                                <DataGrid
                                    autoHeight
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    rowHeight={56}
                                    onRowClick={(params) => {
                                        const { pk_cent_key, cent_name } = params.row;
                                        // no key in URL; pass via router state
                                        navigate("/admin/AdminReportPrimaryStudents/Centre", {
                                            state: { centKey: pk_cent_key, centName: cent_name }
                                        });
                                    }}
                                    slots={{ loadingOverlay: LinearProgress, toolbar: GridToolbar }}
                                    slotProps={{
                                        toolbar: {
                                            csvOptions: { fileName: "PrimaryStudentsByCentre" },
                                            printOptions: { fileName: "PrimaryStudentsByCentre", hideFooter: true, hideToolbar: true },
                                            showQuickFilter: true,
                                        },
                                    }}
                                    disableRowSelectionOnClick
                                    showColumnVerticalBorder
                                    showCellVerticalBorder
                                />
                            </Box>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
}

export default AdminReportPrimaryStudents;
